export default __webpack_public_path__ + "static/media/loader.69391bbb.svg";